import { toast, type ToastOptions } from 'react-toastify';

/** Long enough to read billing / wallet guidance (SONGPLACE-900). */
export const USER_ERROR_TOAST_MS = 12_000;

export const showUserErrorToast = (message: string, options?: ToastOptions) =>
  toast.error(message, {
    autoClose: USER_ERROR_TOAST_MS,
    pauseOnHover: true,
    ...options,
  });
